import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employmenthistory',
  templateUrl: './employmenthistory.component.html',
  styleUrls: ['./employmenthistory.component.less']
})
export class EmploymenthistoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
